import { render } from "./ModuleProgressBar.vue?vue&type=template&id=326f8a6d"
import script from "./ModuleProgressBar.vue?vue&type=script&lang=js"
export * from "./ModuleProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__